import { Document, Page, Text, View, StyleSheet, pdf } from '@react-pdf/renderer';

// Create styles to match the exact design
const styles = StyleSheet.create({
  page: {
    flexDirection: 'column',
    backgroundColor: '#FFFFFF',
    padding: 10,
    fontSize: 9,
  },
  title: {
    fontSize: 14,
    textAlign: 'center',
    marginBottom: 10,
    fontWeight: 'bold',
  },
  mainContainer: {
    border: '1px solid black',
    padding: 0,
  },
  topSection: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
  },
  companySection: {
    width: '65%',
    borderRight: '1px solid black',
    padding: 8,
    minHeight: 50,
  },
  invoiceSection: {
    width: '35%',
    padding: 0,
  },
  invoiceRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    minHeight: 16,
    alignItems: 'center',
  },
  invoiceLabel: {
    width: '50%',
    padding: 4,
    borderRight: '1px solid black',
    fontSize: 8,
    fontWeight: 'bold',
  },
  invoiceValue: {
    width: '50%',
    padding: 4,
    fontSize: 8,
  },
  buyerSection: {
    borderBottom: '1px solid black',
    padding: 8,
    minHeight: 40,
  },
  tableContainer: {
    borderBottom: '1px solid black',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid black',
    minHeight: 25,
    alignItems: 'center',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    minHeight: 18,
    alignItems: 'center',
  },
  // Main table columns matching the image exactly
  col1: { 
    width: '6%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col2: { 
    width: '35%', 
    borderRight: '1px solid black', 
    padding: 3,
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col3: { 
    width: '12%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col4: { 
    width: '10%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col5: { 
    width: '10%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col6: { 
    width: '8%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  col7: { 
    width: '19%', 
    padding: 3, 
    textAlign: 'right',
    fontSize: 8,
    minHeight: 18,
    justifyContent: 'center'
  },
  totalRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    minHeight: 18,
    alignItems: 'center',
    fontWeight: 'bold',
  },
  totalLabel: { 
    width: '81%', 
    padding: 3, 
    textAlign: 'right', 
    fontWeight: 'bold',
    fontSize: 9
  },
  totalValue: { 
    width: '19%', 
    padding: 3, 
    textAlign: 'right', 
    fontWeight: 'bold',
    fontSize: 9
  },
  wordsSection: {
    padding: 8,
    borderBottom: '1px solid black',
    minHeight: 25,
  },
  taxTableContainer: {
    borderBottom: '1px solid black',
  },
  taxTableHeader: {
    flexDirection: 'row',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid black',
    minHeight: 18,
    alignItems: 'center',
  },
  taxTableRow: {
    flexDirection: 'row',
    borderBottom: '1px solid black',
    minHeight: 18,
    alignItems: 'center',
  },
  // Tax table columns
  taxCol1: { 
    width: '15%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8
  },
  taxCol2: { 
    width: '20%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8
  },
  taxCol3: { 
    width: '15%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8
  },
  taxCol4: { 
    width: '25%', 
    borderRight: '1px solid black', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8
  },
  taxCol5: { 
    width: '25%', 
    padding: 3, 
    textAlign: 'center',
    fontSize: 8
  },
  bankSection: {
    padding: 8,
    minHeight: 35,
  },
  footer: {
    textAlign: 'center',
    fontSize: 8,
    marginTop: 10,
  },
  headerText: {
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  cellText: {
    fontSize: 8,
  },
  boldText: {
    fontSize: 8,
    fontWeight: 'bold',
  }
});

// Helper function to get state code
const getStateCode = (stateName) => {
  const stateCodes = {
    'andhra pradesh': '28',
    'arunachal pradesh': '12',
    'assam': '18',
    'bihar': '10',
    'chhattisgarh': '22',
    'goa': '30',
    'gujarat': '24',
    'haryana': '06',
    'himachal pradesh': '02',
    'jharkhand': '20',
    'karnataka': '29',
    'kerala': '32',
    'madhya pradesh': '23',
    'maharashtra': '27',
    'manipur': '14',
    'meghalaya': '17',
    'mizoram': '15',
    'nagaland': '13',
    'odisha': '21',
    'punjab': '03',
    'rajasthan': '08',
    'sikkim': '11',
    'tamil nadu': '33',
    'telangana': '36',
    'tripura': '16',
    'uttar pradesh': '09',
    'uttarakhand': '05',
    'west bengal': '19',
    'delhi': '07'
  };
  
  return stateCodes[stateName?.toLowerCase()] || '00';
};

// Create Document Component
const InvoiceDocument = ({ invoiceData }) => {
  const amount = parseFloat(invoiceData.amount);
  const currency = invoiceData.currency;
  const taxAmount = parseFloat(invoiceData.tax_amount);
  const totalAmount = parseFloat(invoiceData.total_amount);
  console.log(invoiceData, "invoiceData-----------");

  // Dynamic buyer information
  const buyerInfo = invoiceData.buyerInfo || {};
  console.log(invoiceData, "invoiceData");
  
  // Build buyer name
  const buyerName = buyerInfo.company_name || 
    `${buyerInfo.first_name || ''} ${buyerInfo.last_name || ''}`.trim() || 
    buyerInfo.email || 'CUSTOMER';

  // Build address lines
  const addressLines = [];
  if (buyerInfo.billing_address) addressLines.push(buyerInfo.billing_address);
  if (buyerInfo.additional_address) addressLines.push(buyerInfo.additional_address);
  
  // City, State, ZIP
  const cityStateZip = [
    buyerInfo.city,
    buyerInfo.state,
    buyerInfo.zip_code
  ].filter(Boolean).join(', ');
  if (cityStateZip) addressLines.push(cityStateZip);
  
  // Country (if not India)
  if (buyerInfo.country && buyerInfo.country.toLowerCase() !== 'india') {
    addressLines.push(buyerInfo.country);
  }

  // GST/VAT info
  let taxInfo = '';
  if (buyerInfo.gst_number) {
    taxInfo = `GSTIN/UIN: ${buyerInfo.gst_number}`;
  } else if (buyerInfo.vat_number) {
    taxInfo = `VAT: ${buyerInfo.vat_number}`;
  }

  // State with code
  let stateWithCode = '';
  if (buyerInfo.state) {
    getStateCode(buyerInfo.state); // State code calculation
    stateWithCode = `State Name: ${buyerInfo.state}`;
  }

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        <Text style={styles.title}>Tax Invoice</Text>
        
        <View style={styles.mainContainer}>
          {/* Top Section */}
          <View style={styles.topSection}>
            <View style={styles.companySection}>
              <Text style={styles.boldText}>IBRLIVE INDIA PRIVATE LIMITED</Text>
              <Text style={styles.cellText}>2nd Floor, SCO-159, Sector-13-17</Text>
              <Text style={styles.cellText}>Eldeco</Text>
              <Text style={styles.cellText}>GSTIN/UIN: 06AAGCI3134E1ZZ</Text>
              <Text style={styles.cellText}>State Name: Haryana</Text>
            </View>
            
            <View style={styles.invoiceSection}>
              <View style={styles.invoiceRow}>
                <Text style={styles.invoiceLabel}>Invoice No.</Text>
                <Text style={styles.invoiceValue}>{invoiceData.invoice_number}</Text>
              </View>
              <View style={styles.invoiceRow}>
                <Text style={styles.invoiceLabel}>Dated</Text>
                <Text style={styles.invoiceValue}>{new Date(invoiceData.invoice_date).toLocaleDateString('en-GB')}</Text>
              </View>
              <View style={[styles.invoiceRow, { borderBottom: 'none' }]}>
                <Text style={styles.invoiceLabel}>Mode/Terms of Payment</Text>
                <Text style={styles.invoiceValue}>Advance</Text>
              </View>
            </View>
          </View>

          {/* Dynamic Buyer Section */}
          <View style={styles.buyerSection}>
            <Text style={styles.cellText}>Buyer (Bill to)</Text>
            <Text style={styles.boldText}>{buyerName.toUpperCase()}</Text>
            
            {/* Render address lines dynamically */}
            {addressLines.map((line, index) => (
              <Text key={index} style={styles.cellText}>{line}</Text>
            ))}
            
            {/* GST/VAT info */}
            {taxInfo && <Text style={styles.cellText}>{taxInfo}</Text>}
            
            {/* State with code */}
            {stateWithCode && <Text style={styles.cellText}>{stateWithCode}</Text>}
            
            {/* Extra billing info */}
            {buyerInfo.extra_billing_info && (
              <Text style={styles.cellText}>{buyerInfo.extra_billing_info}</Text>
            )}
          </View>

          {/* Main Table */}
          <View style={styles.tableContainer}>
            <View style={styles.tableHeader}>
              <View style={styles.col1}>
                <Text style={styles.headerText}>SI</Text>
                <Text style={styles.headerText}>No</Text>
              </View>
              <View style={styles.col2}>
                <Text style={styles.headerText}>Particulars</Text>
              </View>
              <View style={styles.col3}>
                <Text style={styles.headerText}>SAC</Text>
              </View>
              <View style={styles.col4}>
                <Text style={styles.headerText}>Quantity</Text>
              </View>
              <View style={styles.col5}>
                <Text style={styles.headerText}>Rate</Text>
              </View>
              <View style={styles.col6}>
                <Text style={styles.headerText}>per</Text>
              </View>
              <View style={styles.col7}>
                <Text style={styles.headerText}>Amount</Text>
              </View>
            </View>
            
            <View style={styles.tableRow}>
              <View style={styles.col1}>
                <Text style={styles.cellText}>1</Text>
              </View>
              <View style={styles.col2}>
                <Text style={styles.cellText}>{invoiceData.plan_name} API Service</Text>
              </View>
              <View style={styles.col3}>
                <Text style={styles.cellText}>{invoiceData.sac_code || '440153'}</Text>
              </View>
              <View style={styles.col4}>
                <Text style={styles.cellText}>1</Text>
              </View>
              <View style={styles.col5}>
                <Text style={styles.cellText}>{amount.toFixed(2)}</Text>
              </View>
              <View style={styles.col6}>
                <Text style={styles.cellText}>Nos</Text>
              </View>
              <View style={styles.col7}>
                <Text style={styles.cellText}>{amount.toFixed(2)}</Text>
              </View>
            </View>
            
            <View style={styles.tableRow}>
              <View style={styles.col1}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.col2}>
                <Text style={styles.cellText}>IGST (18%)</Text>
              </View>
              <View style={styles.col3}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.col4}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.col5}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.col6}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.col7}>
                <Text style={styles.cellText}>{taxAmount.toFixed(2)}</Text>
              </View>
            </View>
            
            <View style={styles.totalRow}>
              <View style={styles.totalLabel}>
                <Text style={styles.boldText}>Total</Text>
              </View>
              <View style={styles.totalValue}>
                <Text style={styles.boldText}>{currency === "INR" ? "INR" : "$"} {totalAmount.toFixed(2)}</Text>
              </View>
            </View>
          </View>

          {/* Amount in Words */}
          <View style={styles.wordsSection}>
            <Text style={styles.cellText}>Amount Chargeable (in words)</Text>
            <Text style={styles.boldText}>INR {numberToWords(totalAmount)} Only</Text>
          </View>

          {/* Tax Summary Table */}
          <View style={styles.taxTableContainer}>
            <View style={styles.taxTableHeader}>
              <View style={styles.taxCol1}>
                <Text style={styles.headerText}>SAC</Text>
              </View>
              <View style={styles.taxCol2}>
                <Text style={styles.headerText}>Taxable Value</Text>
              </View>
              <View style={styles.taxCol3}>
                <Text style={styles.headerText}>IGST Rate</Text>
              </View>
              <View style={styles.taxCol4}>
                <Text style={styles.headerText}>IGST Amount</Text>
              </View>
              <View style={styles.taxCol5}>
                <Text style={styles.headerText}>Total Tax Amount</Text>
              </View>
            </View>
            
            <View style={styles.taxTableRow}>
              <View style={styles.taxCol1}>
                <Text style={styles.cellText}>{invoiceData.sac_code || '440153'}</Text>
              </View>
              <View style={styles.taxCol2}>
                <Text style={styles.cellText}>{amount.toFixed(2)}</Text>
              </View>
              <View style={styles.taxCol3}>
                <Text style={styles.cellText}>18%</Text>
              </View>
              <View style={styles.taxCol4}>
                <Text style={styles.cellText}>{taxAmount.toFixed(2)}</Text>
              </View>
              <View style={styles.taxCol5}>
                <Text style={styles.cellText}>{taxAmount.toFixed(2)}</Text>
              </View>
            </View>
            
            <View style={styles.taxTableRow}>
              <View style={styles.taxCol1}>
                <Text style={styles.boldText}>Total</Text>
              </View>
              <View style={styles.taxCol2}>
                <Text style={styles.cellText}>{amount.toFixed(2)}</Text>
              </View>
              <View style={styles.taxCol3}>
                <Text style={styles.cellText}></Text>
              </View>
              <View style={styles.taxCol4}>
                <Text style={styles.cellText}>{taxAmount.toFixed(2)}</Text>
              </View>
              <View style={styles.taxCol5}>
                <Text style={styles.cellText}>{taxAmount.toFixed(2)}</Text>
              </View>
            </View>
          </View>

          {/* Tax Amount in Words */}
          <View style={styles.wordsSection}>
            <Text style={styles.cellText}>Tax Amount (in words): INR {numberToWords(taxAmount)} Only</Text>
          </View>

          {/* Bank Details */}
          <View style={styles.bankSection}>
            <Text style={styles.boldText}>Company's Bank Details</Text>
            <Text style={styles.cellText}>Bank Name: ICICI BANK</Text>
            <Text style={styles.cellText}>A/c No.: 093405003734</Text>
            <Text style={styles.cellText}>Branch & IFS Code: Eldeco & ICIC0005462</Text>
          </View>
        </View>

        <Text style={styles.footer}>This is a Computer Generated Invoice</Text>
      </Page>
    </Document>
  );
};

// Generate PDF function
export const generateInvoicePDF = async (invoiceData) => {
  const doc = <InvoiceDocument invoiceData={invoiceData} />;
  const asPdf = pdf(doc);
  const blob = await asPdf.toBlob();
  
  // Create download link
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `Invoice_${invoiceData.invoice_number}.pdf`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

function numberToWords(number) {
  const ones = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
  const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];
  const teens = ['Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];

  const convertLessThanOneThousand = (n) => {
    if (n === 0) return '';
    if (n < 10) return ones[n];
    if (n < 20) return teens[n - 10];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + ones[n % 10] : '');
    return ones[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + convertLessThanOneThousand(n % 100) : '');
  };

  const num = Math.floor(number);
  if (num === 0) return 'Zero';

  const thousands = Math.floor(num / 1000);
  const remainder = num % 1000;

  let words = '';
  if (thousands) {
    words += convertLessThanOneThousand(thousands) + ' Thousand';
  }
  if (remainder) {
    words += (words ? ' ' : '') + convertLessThanOneThousand(remainder);
  }

  return words;
}

export default generateInvoicePDF;